import { Card, CardContent } from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import MutliTagAutoCompleteField from "@saleor/components/MutliTagAutoCompleteField";
import { FormChange } from "@saleor/hooks/useForm";
import { ShopifyTagEnum } from "@saleor/types/globalTypes";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import { SellerDetailsPageFormData } from "../SellerDetailsPage/SellerDetailsPages";

export interface ShopifyTagsProps {
  data: SellerDetailsPageFormData;
  shopifyExclusionTags: string;
  shopifyNonCodTags: string;
  onChange: FormChange;
  onAdd: (tag: string, type: ShopifyTagEnum) => void;
  onRemove: (tag: string, type: ShopifyTagEnum) => void;
}

export const ShopifyTags: React.FC<ShopifyTagsProps> = ({
  data,
  onAdd,
  onRemove
}) => {
  const intl = useIntl();

  const [tagText, setTagText] = useState("");
  const handleChangeTag = (e, type: ShopifyTagEnum) => {
    const getValue = e.target.value;
    onRemove(getValue, type);
  };

  const handleTagAdd = (type: ShopifyTagEnum) => {
    onAdd(tagText, type);
  };

  return (
    <Card>
      <CardTitle title="Shopify Tags" />
      <CardContent>
        <MutliTagAutoCompleteField
          manualAdd={() => handleTagAdd(ShopifyTagEnum.EXCLUSION)}
          displayValues={data.shopifyExclusionTags.map(item => ({
            label: item,
            value: item
          }))}
          label={intl.formatMessage({
            defaultMessage: "Blacklist Tag"
          })}
          choices={[]}
          limit={10}
          name="shopifyExclusionTags"
          value={data.shopifyExclusionTags.map(item => item)}
          onChange={e => {
            handleChangeTag(e, ShopifyTagEnum.EXCLUSION);
          }}
          onChangeText={setTagText}
          onRemove={e => onRemove(e.target.value, ShopifyTagEnum.EXCLUSION)}
          fetchChoices={() => undefined}
          onFetchMore={() => undefined}
          hasMore={false}
          loading={false}
        />
        {/* <TextField
          label={intl.formatMessage({
            defaultMessage: "Blacklist Tag",
            description: "Blacklist Tag"
          })}
          value={data?.shopifyExclusionTags || ""}
          name="shopifyExclusionTags"
          type="text"
          inputProps={{ maxLength: 500 }}
          onChange={onChange}
          fullWidth
        /> */}
        <FormSpacer />
        <MutliTagAutoCompleteField
          manualAdd={() => handleTagAdd(ShopifyTagEnum.NON_COD)}
          displayValues={data.shopifyNonCodTags.map(item => ({
            label: item,
            value: item
          }))}
          label={intl.formatMessage({
            defaultMessage: "Non-COD"
          })}
          choices={[]}
          limit={10}
          name="shopifyNonCODTags"
          value={data.shopifyNonCodTags.map(item => item)}
          onChange={e => {
            handleChangeTag(e, ShopifyTagEnum.NON_COD);
          }}
          onChangeText={setTagText}
          onRemove={e => onRemove(e.target.value, ShopifyTagEnum.NON_COD)}
          fetchChoices={() => undefined}
          onFetchMore={() => undefined}
          hasMore={false}
          loading={false}
        />
        {/* <TextField
          label={intl.formatMessage({
            defaultMessage: "Non-COD",
            description: "Non-COD"
          })}
          value={data?.shopifyNonCodTags || ""}
          name="shopifyNonCodTags"
          type="text"
          inputProps={{ maxLength: 500 }}
          onChange={onChange}
          fullWidth
        /> */}
      </CardContent>
    </Card>
  );
};

ShopifyTags.displayName = "ShopifyTag";
export default ShopifyTags;
